import React from 'react';
import { CountdownTimer } from './CountdownTimer';
import { PAYMENT_LINK } from '../utils/constants';
export function FinalCTA() {
  return <section className="py-16 md:py-24 px-4 bg-blue-900 text-white text-center" data-id="element-72">
      <div className="max-w-4xl mx-auto" data-id="element-73">
        <h2 className="text-3xl md:text-5xl font-bold mb-6 leading-tight" data-id="element-74">
          🎶 Diventa l'insegnante di musica che i tuoi studenti ricorderanno
          davvero
        </h2>
        <p className="text-xl text-blue-200 mb-10 max-w-2xl mx-auto" data-id="element-75">
          Accedi ora al MegaPack Maestro Musicale 360° e trasforma il tuo modo
          di insegnare.
        </p>

        <div className="flex justify-center mb-10" data-id="element-76">
          <CountdownTimer variant="light" data-id="element-77" />
        </div>

        <a href={PAYMENT_LINK} target="_blank" rel="noopener noreferrer" className="inline-block bg-green-500 hover:bg-green-600 text-white rounded-full py-5 px-12 font-bold text-xl md:text-2xl shadow-lg shadow-green-500/30 animate-pulse-fast transition-all transform hover:scale-105" data-id="element-78">
          🟢 ACQUISTA ORA
        </a>
      </div>
    </section>;
}